import { queryOptions, useQuery } from "@tanstack/react-query";
import { fetchFacilityMaturityEvents } from "../api/enterpriseClient";

export const facilityMaturityEventsQueryOptions = (
  customerId: number,
  facilityId: number,
) =>
  queryOptions({
    queryKey: ["enterprise-facility-maturity-events", customerId, facilityId],
    queryFn: () => fetchFacilityMaturityEvents(customerId, facilityId),
    staleTime: 60_000,
  });

export function useGetFacilityMaturityEvents(
  customerId: number,
  facilityId: number,
) {
  return useQuery(facilityMaturityEventsQueryOptions(customerId, facilityId));
}
